import { authHeaders } from './entitlements';

export interface PrescriberView {
  nombre: string;
  registroAcess: string;
  telefono: string;
  hasFirma: boolean;
}

export interface EncounterView {
  id: number;
  seqReceta: string;
  seqHistoria: string;
  dictadoRaw: string;
  receta: unknown;
  historia: unknown;
  createdAt: string;
  createdBy: string;
}

async function clinicJson<T>(url: string, init?: RequestInit): Promise<T> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json', ...(authHeaders() as Record<string, string>) };
  const res = await fetch(url, { ...init, headers: { ...headers, ...(init?.headers as Record<string, string> | undefined) } });
  const text = await res.text();
  if (!res.ok) {
    try {
      const body = JSON.parse(text) as { message?: string };
      throw new Error(body.message || text || res.statusText);
    } catch (err) {
      if (err instanceof SyntaxError) throw new Error(text || res.statusText);
      throw err;
    }
  }
  return (text ? JSON.parse(text) : null) as T;
}

export function loadPrescriber(): Promise<PrescriberView> {
  return clinicJson('/api/clinic/prescriber');
}

export function savePrescriber(body: {
  nombre: string;
  registroAcess: string;
  telefono: string;
  firmaPngBase64?: string;
}): Promise<PrescriberView> {
  return clinicJson('/api/clinic/prescriber', { method: 'PUT', body: JSON.stringify(body) });
}

export function listEncounters(): Promise<{ items: EncounterView[] }> {
  return clinicJson('/api/clinic/encounters');
}

export function getEncounter(id: string): Promise<EncounterView> {
  return clinicJson(`/api/clinic/encounters/${encodeURIComponent(id)}`);
}

export function createEncounter(body: unknown): Promise<EncounterView> {
  return clinicJson('/api/clinic/encounters', { method: 'POST', body: JSON.stringify(body) });
}
